import { render, staticRenderFns } from "./PostRejected.vue?vue&type=template&id=18212751&scoped=true&"
import script from "./PostRejected.vue?vue&type=script&lang=js&"
export * from "./PostRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18212751",
  null
  
)

export default component.exports